import React, { useEffect, useState } from 'react';
import AllForBottom from './AllForBottom';
import SwipeableViews from 'react-swipeable-views';
import AllForGalleryHome from '../GalleryHome/AllForGalleryHome';
// import AllForMe from '../Me/AllForMe';
import PageMe from '../../pages/Me';

// import AllForAppointment from '../Appointment/AllForAppointment';
import AllForMyPhotos from '../MyPhotos/AllForMyPhotos';
import AllForFollowee from '../Followee/AllForFollowee';
import AllForComment from '../../components/Comment/AllForComment';
import AllRedPackComponents from '../../components/RedPack/AllRedPackComponents';
import { IComponentNavigator, IComponentPendent } from '../../component';
import { inject, observer } from 'mobx-react';
import { observable, action } from 'mobx';
import RootStore from '../../store/RootStore';
import { throttle, containClassName, browser, toOrderPage } from '../../utils/util';
import { checkLoadMore, ILoadMoreResult } from '../Common/ListWrapper';
import ComponentLink from '../ComponentLink';
import AllForPendant from '../ComponentPendant/AllForPendant';
import AllForPendantV2 from '../ComponentPendantV2/AllForPendant';
import ScrollToTop from '../ComponentPendant/ScrollToTop';
import wxUtil from '../../utils/wx';
import './MainTab.scss';

// import asyncComponent from '../../components/AsyncComponent';
// const AllForAppointment = asyncComponent(() =>
//   import('../Appointment/AllForAppointment')
// );

interface IMainTab {
  rootStore?: RootStore;
}

let myselfPage = 1;
let followerPage = 1;
let initial = false;

const findSpecParent = (source: any, className: string) => {
  let target = null;
  while (
    source.parentNode &&
    source.parentNode.tagName.toUpperCase() != 'BODY'
  ) {
    if (
      source.parentNode &&
      source.parentNode.className.indexOf(className) > -1
    ) {
      target = source.parentNode;
      break;
    } else {
      source = source.parentNode;
    }
  }

  return target;
};

const fixedScroll = () => {
  // @ts-ignore
  let lastTouch: any = null;
  window.document.body.addEventListener('touchstart', (e: any) => {
    let { touches } = e;
    lastTouch = touches[0];
  });
  window.document.body.addEventListener('touchend', (e: any) => {
    lastTouch = null;
  });
  window.document.body.addEventListener(
    'touchmove',
    (e: any) => {
      let { touches } = e;
      let item = touches[0];

      if (
        containClassName(e.target.className, [
          'bottom-tab',
          'bottom-tab-one',
          'ignore-move'
        ])
      ) {
        console.log(5);
        e.preventDefault();
        e.stopPropagation();
        return false;
      }

      let container = findSpecParent(
        e.target,
        'react-swipeable-view-container'
      );

      if (
        container &&
        !findSpecParent(container, 'react-swipeable-view-container') &&
        findSpecParent(container, 'root')
      ) {
        let slide = container.querySelector(':scope>div[aria-hidden=false]');
        let slideDiv = slide.querySelector(':scope>div');
        if (
          !!lastTouch &&
          !!item &&
          item.pageY > lastTouch.pageY &&
          slide &&
          slide.scrollTop == 0
        ) {
          console.log(1);
          e.preventDefault();
          e.stopPropagation();
          return false;
        } else if (
          lastTouch &&
          item &&
          item.pageY < lastTouch.pageY &&
          slide &&
          slideDiv &&
          slide.scrollTop >= slideDiv.clientHeight - slide.clientHeight
        ) {
          console.log(4);
          e.preventDefault();
          e.stopPropagation();
          return false;
        }

        e.stopPropagation();
      }
    },
    {
      passive: false
    }
  );
};

// 获取底部导航，注意，有可能为空，比如引导页
export const getNavigator = function () {
  const { pageDetail } = window;
  const { template } = pageDetail;
  // navigator是个特殊的组件，没法只能在这一层处理
  const navigator = template.find(
    one => one.type === 'navigator'
  ) as IComponentNavigator | null;
  return navigator;
};

// 挂件单独处理一下？2019-09-05
const getPendant = function () {
  const { pageDetail } = window;
  const { template } = pageDetail;
  // navigator是个特殊的组件，没法只能在这一层处理
  const navigator = template.find(
    one => one.type === 'pendent'
  ) as IComponentPendent | null;
  return navigator;
};

let swipeableActions = {} as any;
let lastScrollY = 0;

const MainTab = (props: IMainTab) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [currentTab, setCurrentTab] = useState(null as any);
  const {
    relationStore,
    pagedataStore,
    galleryStore,
    wxuserStore
  } = props.rootStore!;
  const { jigsaw } = galleryStore;
  // 如果当前是拼图底部已经显示的情况下，任何挂件都不需要显示
  const { bottomShow } = jigsaw;
  // navigator是个特殊的组件，没法只能在这一层处理
  const navigator = getNavigator();
  const pendent = getPendant();
  const { my = false, order = false } = navigator || {};

  const { configDetail, pageDetail, gallery } = window;
  const { use_comment, use_package, use_tip } = configDetail;

  useEffect(() => {
    pagedataStore.getParentPgData(window.pageDetail!.link_id).then((dt: any) => {
      const { template, link_id } = dt;
      pagedataStore.setParentLinkId(link_id);
    });
  }, []);

  useEffect(() => {
    if (currentTab) {
      if (currentTab.id == 2) {
        myselfRefresh();
      }
      if (currentTab.id == 3) {
        relationStore.follower().then(() => {
          props.rootStore!.galleryStore.getPersonList(
            (window.dataDetail ? window.dataDetail!.id : window.gallery.id) +
            '',
            1
          );
        });
      }
    }

    if (!initial) {
      // fixedScroll引起了很多划不动的问题，比如人脸识别页面的头像拖动问题
      // 怎么三星也有这个鬼交互
      // 判断一下是否为ios
      // if (browser.versions.iPhone) {
      // fixedScroll();
      // }
      initial = true;
    }
  }, [currentTab]);

  // 监听全部事件
  useEffect(() => {
    const mainIndexChange = (e: any) => {
      let { data } = e;
      if (data && data.id) {
        if (data.id == 5) {
          let index = 1;
          if (
            !!+window.configDetail.use_face &&
            Number(window.configDetail.active_on)
          ) {
            index += 2;
          }

          if (order) {
            index += 1;
          }

          setCurrentIndex(index);
        }
      }
    };

    window.addEventListener('main-index', mainIndexChange);

    return () => {
      window.removeEventListener('main-index', mainIndexChange);
    };
  }, [currentTab]);

  const getEventName = (index: number, tab: any) => {
    if (!tab && index == 0) {
      return `gallery-list`;
    }
    if (tab && tab.id == 1) {
      return `gallery-list`;
    }
    if (tab && tab.id == 2) {
      return `myself`;
    }
    if (tab && tab.id == 3) {
      return `follower`;
    }
    if (tab && tab.id == 5) {
      return `me`;
    }
    return '';
    // switch (index) {
    //   case 0:
    //     return 'gallery-list';
    //   case 1:
    //     return 'myself';
    //   case 2:
    //     return 'follower';
    //   default:
    //     return '';
    // }
  };

  const notifyToBottom = throttle(
    (index: number, tab: any) => {
      const theEventName = 'to-bottom-' + getEventName(index, tab);
      console.log('dispatch ', theEventName);
      // 这个实在是太难处理了，只好用事件了
      // 最外层的main tab只管gallery-list的处理
      window.dispatchEvent(new Event(theEventName));
    },
    1000,
    {
      leading: true,
      trailing: false // 最后一个不调用
    }
  );

  // 本人照片
  const myselfRefresh = () => {
    myselfPage = 1;
    return relationStore.updateMyself(window.gallery!.id + '').then(() => {
      wxUtil.configPersonShare(relationStore.myself.id);
      return relationStore.getMyselfAlbum(
        window.dataDetail ? window.dataDetail.id + '' : window.gallery.id + '',
        myselfPage
      );
    });
  };
  const myselfLoadMore = () => {
    myselfPage++;
    return relationStore
      .getMyselfAlbum(
        window.dataDetail ? window.dataDetail.id + '' : window.gallery.id + '',
        myselfPage
      )
      .then(checkLoadMore);
  };

  const renderChildren = (
    showMy: boolean,
    order: boolean,
    hasNavigator: boolean
  ) => {
    const children = [<AllForGalleryHome key={1} />];
    //有底部才渲染后面2个，并且还要看是否开启了微信授权
    !!+window.configDetail.use_face &&
      Number(window.configDetail.active_on) &&
      hasNavigator &&
      children.push(
        <AllForMyPhotos
          key={2}
          // loadMore={myselfLoadMore} // 我的照片界面，其实不需要分页，免得一直去请求接口
          loadMore={() =>
            new Promise(resolve => resolve({ nomore: true, message: '' }))
          }
          refresh={myselfRefresh}
          eventName={'myself'}
        />
      );
    !!+window.configDetail.use_face &&
      Number(window.configDetail.active_on) &&
      hasNavigator &&
      children.push(<AllForFollowee key={3} />);
    // order && children.push(<AllForAppointment key={4} />);
    order && children.push(<div key={4} />);
    // children.push(<AllForAppointment key={4} />);
    showMy &&
      children.push(
        // <AllForMe
        //   key={5}
        //   setMainTabIndex={index => {
        //     setCurrentIndex(index);
        //     if (Number(index) === 1) {
        //       setCurrentTab({
        //         id: 2
        //       });
        //     }
        //     if (Number(index) === 2) {
        //       setCurrentTab({
        //         id: 3
        //       });
        //     }
        //   }}
        // />
        <PageMe key={5} />
      );
    return children;
  };

  const nonScrollParentClass = [
    'all-for-big-pic-person-list',
    'ignore-move',
    'no-bottom-touch'
  ];

  // 递归获取当前节点是否需要监听scroll，如果返回了false，说明当前节点不需要监听滚动事件
  // 否则滑动到底部会触发to-bottom-XXXX事件
  const getNonScrollParentElement = (e: HTMLElement): boolean => {
    // console.log(e.classList);
    if (
      e &&
      e.classList &&
      nonScrollParentClass.some(cls => e.classList.contains(cls))
    ) {
      return false;
    }
    const parent = e.parentElement;
    if (!parent || parent === document.body) {
      return true;
    } else {
      return getNonScrollParentElement(parent);
    }
  };

  // const nonScrollListenElement = (el:Element)=>{
  //   getNonScrollParentElement(el);
  // }

  // 新版的话，应该是走windows的scroll事件
  useEffect(() => {
    const scroll = (e: any) => {
      // 有可能最多有3个index需要考虑监听事件
      // 0: gallery-list
      // 1: 在 已登录 &&
      //     hasNavigator 时
      // 2: 条件同上
      // if (currentIndex > 2) {
      //   return;
      // }
      if (currentTab && (currentTab.id == 3 || currentTab.id == 4)) {
        return;
      }
      if (currentIndex !== 0) {
        if (!(!wxuserStore.user.is_mock && navigator)) {
          return;
        }
      }

      if (!getNonScrollParentElement(e.target as HTMLDivElement)) {
        return;
      }

      // 一旦通过上面的验证，认为1 就是本人照片， 2就是关注的人

      //console.log((e.target as HTMLDivElement).scrollTop, (e.target as HTMLDivElement).scrollHeight);
      // const { target } = e;
      // const { scrollTop, scrollHeight } = target as HTMLDivElement;
      const scrollTop = window.scrollY;
      const scrollHeight = window.document.body.scrollHeight;

      // 容忍度 可以考虑尽量高一点
      const tolerate = 200;
      if (
        scrollTop /* + document.body.clientHeight */ + window.innerHeight >=
        scrollHeight - tolerate &&
        scrollHeight > window.innerHeight + tolerate
      ) {
        // console.log('to bottom', scrollTop, document.body.clientHeight, scrollHeight);
        // @ts-ignore
        notifyToBottom(currentIndex, currentTab);
      }
    };

    window.addEventListener('scroll', scroll);

    return () => {
      window.removeEventListener('scroll', scroll);
    };
  }, [currentIndex, currentTab]);

  const showMy = my;
  return (
    <>
      <SwipeableViews
        // @ts-ignore
        action={actions => {
          swipeableActions = actions;
          if (swipeableActions && swipeableActions.updateHeight) {
            swipeableActions.updateHeight();
          }
        }}
        index={currentIndex}
        onChangeIndex={index => {
          setCurrentIndex(index);
        }}
        id="mainTab"
        style={{ flex: 1 }}
        //ios smooth 需要webkitOverflowScrolling(大小写无所谓)，神奇的是居然在浏览器上看不到这个属性
        // containerStyle={{ height: '100%', WebkitOverflowScrolling: 'touch' }}
        // slideStyle={{willChange:'scroll-position'}}
        // onScroll={scroll}
        disabled={true}
      >
        {renderChildren(showMy, order, !!navigator)}
      </SwipeableViews>
      <AllForBottom
        component={navigator}
        navigatorShow={!!navigator}
        currentIndex={currentIndex}
        onClick={(index: number, tab: any) => {
          let event = new Event('PENDENT_CHANGE');

          if (tab) {
            if (tab.id == 2 || tab.id == 3 || tab.id == 5) {
              // 这些都是需要登录信息的
              let { user } = wxuserStore;
              if (user && !!+user.is_mock) {
                wxuserStore.auth();
                return;
              }
            }
            if (tab.id == 4) {
              return toOrderPage('from_order_bottom');
            }
          }

          if (index == 0) {
            event.action = 'reset';
          } else {
            event.buttons = [];
            event.action = 'event';
          }
          window.dispatchEvent(event);

          // 向全局发布一次主index变更通知
          let indexEvent = new Event('SWIPER_INDEX_CHANGE');
          indexEvent.data = index;
          window.dispatchEvent(indexEvent);

          // 当前点击的第0项，切第0项是高亮，则返回到父级去
          if (index === 0 && currentIndex === 0) {
            // TODO 如果上一页的记录与浏览器记录的history一致，是否可以直接用history的back来达到较丝滑的动画效果
            ComponentLink.to('/g/' + pagedataStore.parentLinkId);
          }
          setCurrentIndex(index);
          setCurrentTab(tab);

          if (swipeableActions && swipeableActions.updateHeight) {
            swipeableActions.updateHeight();
          }

          // 修正滚动值
          if (index == 0) {
            setTimeout(() => {
              window.scrollTo(0, lastScrollY);
            }, 500);
          } else {
            lastScrollY = window.scrollY;
            window.scrollTo(0, 0);
          }
        }}
        my={showMy}
        order={order}
      />
      {/*navigator ? (
        <>
          <AllForBottom
            currentIndex={currentIndex}
            onClick={(index: number, tab: any) => {
              let event = new Event('PENDENT_CHANGE');

              if (tab) {
                if (tab.id == 2 || tab.id == 3 || tab.id == 5) {
                  // 这些都是需要登录信息的
                  let { user } = wxuserStore;
                  if (user && !!+user.is_mock) {
                    wxuserStore.auth();
                    return;
                  }
                }
              }

              if (index == 0) {
                event.action = 'reset';
              } else {
                event.buttons = [];
                event.action = 'event';
              }
              window.dispatchEvent(event);

              // 向全局发布一次主index变更通知
              let indexEvent = new Event('SWIPER_INDEX_CHANGE');
              indexEvent.data = index;
              window.dispatchEvent(indexEvent);

              // 当前点击的第0项，切第0项是高亮，则返回到父级去
              if (index === 0 && currentIndex === 0) {
                ComponentLink.to('/g/' + pagedataStore.parentLinkId);
              }
              setCurrentIndex(index);
              setCurrentTab(tab);

              if (swipeableActions && swipeableActions.updateHeight) {
                swipeableActions.updateHeight();
              }

              // 修正滚动值
              if (index == 0) {
                setTimeout(() => {
                  window.scrollTo(0, lastScrollY);
                }, 500);
              } else {
                lastScrollY = window.scrollY;
                window.scrollTo(0, 0);
              }
            }}
            my={showMy}
            order={order}
          />
        </>
      ) : null*/}
      {/*!bottomShow*/ pagedataStore.renderMode != 'pc' && // 此处由于 bottomShow的变更，导航组件被重新渲染了，一些与其它组件的关联事件，不能重放，所以只做隐藏，不做销毁 --20210531
        (pendent && pendent.api == 'v2' ? (
          <AllForPendantV2
            {...(pendent || {
              cid: '',
              type: 'pendent',
              container: {
                right: 10,
                bottom: 50,
                left: 'auto',
                top: 'auto'
              },
              buttons: []
            })}
          />
        ) : (
          <AllForPendant
            {...(pendent || {
              cid: '',
              type: 'pendent',
              container: {
                right: 10,
                bottom: 50,
                left: 'auto',
                top: 'auto'
              },
              buttons: []
            })}
          />
        ))}
      {/*注意，下面的方案会导致每次显示隐藏的时候会重新加载当前2个组件，会重新发送协议，目前不打算优化，先就这样吧*/}
      {!bottomShow && !!use_comment && <AllForComment />}
      {!bottomShow && !!use_package && <AllRedPackComponents />}
    </>
  );
};
export default inject('rootStore')(observer(MainTab));
